import React, { FC, useState } from 'react'
import { observer } from 'mobx-react'
import { cartMobx, doComboMobx, restaurantConfig } from 'restaurant'
import { ConfirmModal } from '@cps'
import { ProductImage, Tags } from 'components'
import './SelectProductModal.scss'

interface IProps {
  type: 'add' | 'show' | 'remove';
  products?: IViewComboCartItem[];
  reject?: () => void;
  resolve?: (data: any) => void;
}

const SelectShowProduct: FC<IProps> = ({ type, products, resolve, reject }) => {
  const { groupNoProductPkReadyMap } = doComboMobx
  const [delProducts, setDelProducts] = useState([])

  const handleClick = (product: IViewComboCartItem) => {
    if (type === 'add' || type === 'show') {
      resolve(product)
    } else {
      setDelProducts([...delProducts, product])
    }
  }

  const handleConfirm = () => {
    resolve(delProducts)
  }

  // render product
  const rendProduct = () => (
    products.filter(product => !delProducts.find(item => product.pk === item.pk)).map(product => (
      <div className='product-item' key={product.pk} data-cypid={`productItem${product?.productNo}`} onClick={() => handleClick(product)}>
        <div className='item-detail'>
          <ProductImage color={!product.pic && restaurantConfig.displayMode === 'waterfall' ? product.productNo : ''} width={40} imgSrc={product.pic} />
          <div className=''>
            <strong>{product.name}</strong>
            <Tags datas={[...(product.tags || []), ...(product.allergys || [])]} disableTogo={cartMobx.info.eatType !== 'dinein' && !product.isCanTogo} disableSingleSale={!product.isSingleSale} />
            {product.intro ? <div className='product-intro' dangerouslySetInnerHTML={{ __html: product.intro }}></div> : ''}
            <div className='product-option'>
              {product.scaleName ? product.scaleName : ''}
              {product.scaleName && (!groupNoProductPkReadyMap[product.groupNo][product.pk] || product.modifierStr) ? ',' : ''}
              {
                !groupNoProductPkReadyMap[product.groupNo][product.pk] ? (
                  <span>{i18n.t('newCart.modifierTips')}</span>
                ) : (<div dangerouslySetInnerHTML={{ __html: product.modifierHtml }}></div>)
              }
            </div>
          </div>
        </div>
        <div className='item-operate'>
          {
            type === 'add' && product.modifierGroups.length ? (
              <div className='button add'>
                <i className='iconfont icon-add' />
                {i18n.t('newCart.modifier')}
              </div>
            ) : ''
          }
          {
            type === 'show' ? (
              <div className='button show'>
                {i18n.t('newCart.view')}
              </div>
            ) : ''
          }
          {
            type === 'remove' ? (
              <div className='button remove'>
                <i className='iconfont icon-huabanbeifen32x' />
              </div>
            ) : ''
          }
        </div>
      </div>
    ))
  )

  return (
    <ConfirmModal
      className='select-combo-product-modal'
      title={i18n.t(type === 'show' ? 'newCart.selectShowProduct' : type === 'remove' ? 'newCart.selectDeleteProduct' : 'newCart.selectModiferProduct')}
      hasFooter={type === 'remove'}
      cancelText={i18n.t('common.cancel')}
      children={rendProduct()}
      resolve={handleConfirm}
    />
  )
}

export default observer(SelectShowProduct)
